<mat-toolbar id="header" name="header" class="mat-elevation-z4 branding">
	<mat-toolbar-row>
		<div fxLayout="row" fxFlex="100%" fxLayoutAlign="center center">
			<div fxFlex="60%" fxLayout="column" fxLayoutAlign="center center">
				<!--LEFT MENU ITEMS-->
				<div fxFill fxLayout="row" fxLayoutAlign="start center">
					<!--MENU BUTTON-->
					<button
						*ngIf="this.isLoggedIn"
						mat-icon-button
						(click)="toggleSidenav()"
						[ngStyle]="{
							color: sidenavActiveItem === 'menu' ? '#32BF55' : '#000000'
						}"
					>
						<mat-icon>menu</mat-icon>
					</button>
					<button
						*ngIf="!this.isLoggedIn"
						mat-icon-button
						fxHide.gt-sm="true"
						fxHide.sm="false"
						[matMenuTriggerFor]="mobileMenu"
						(menuOpened)="mobileMenuOpened()"
						(menuClosed)="mobileMenuClosed()"
						[ngStyle]="{
							color: mobileActiveItem === 'mobilemenu' ? '#32BF55' : '#000000'
						}"
					>
						<mat-icon>menu</mat-icon>
					</button>
					<!-- onerror="this.src='https:\/\/res.cloudinary.com/whydonate/image/upload/dpr_auto,f_auto,q_auto/whydonate-production/platform/visuals/new_design_logo';this.onerror='';" -->
					<!--HIDE IF MOBILE-->
					<button
						*ngIf="!isCustomDomainActive"
						fxHide.sm="true"
						fxHide.xs="true"
						mat-flat-button
						[matMenuTriggerFor]="exploreMenu"
						(menuOpened)="menuOpened()"
						(menuClosed)="menuClosed()"
						[ngStyle]="{
							color: activeItem === 'explore' ? '#32BF55' : '#000000'
						}"
					>
						<span i18n="@@header_explore">Explore</span>
					</button>

					<button
						*ngIf="!isCustomDomainActive"
						i18n="@@home_label_personalFundraising"
						fxHide.sm="true"
						fxHide.xs="true"
						mat-flat-button
						id="homePersonalFundraising"
						(click)="this.routeToPersonalFundraising()"
						[ngStyle]="{
							color: activeItem === 'individuals' ? '#32BF55' : '#000000'
						}"
					>
						For Individuals
					</button>
					<button
						*ngIf="!isCustomDomainActive"
						i18n="@@home_organisation_button"
						fxHide.sm="true"
						fxHide.xs="true"
						mat-flat-button
						id="homeOrganisation"
						(click)="this.routeToOrganisation()"
						[ngStyle]="{
							color: activeItem === 'organisation' ? '#32BF55' : '#000000'
						}"
					>
						For Organisations
					</button>
					<button
						*ngIf="isCustomDomainActive"
						i18n="@@customDomain_home_button"
						fxHide.sm="true"
						fxHide.xs="true"
						mat-flat-button
						id="homeOrganisation"
						(click)="this.routeToPersonalFundraising()"
						[ngStyle]="{
							color: activeItem === 'organisation' ? '#32BF55' : '#000000'
						}"
					>
						Home
					</button>
					<button
						*ngIf="isCustomDomainActive"
						class="search"
						fxHide.sm="true"
						fxHide.xs="true"
						i18n="@@header_menu_button_searchFundraisers"
						mat-flat-button
						id="headerSearchFundraiser"
						(click)="routeToSearch()"
						[ngStyle]="{
							color: activeItem === 'search' ? '#32BF55' : '#000000'
						}"
					>
						Search
					</button>
					<mat-menu
						#exploreMenu="matMenu"
						id="headerExploreMenu"
						class="exploreMenuContainer"
					>
						<div fxFlex="100%" fxLayout="row" ngClass="p-l">
							<div
								fxFlex="100%"
								fxLayout="row"
								fxLayoutAlign="space-between start"
							>
								<!--FUNDRAISER FOR---------------------------------------------------------------------->
								<div fxFlex="100%" ngClass="p-r-l">
									<app-fundraiser-for></app-fundraiser-for>
								</div>

								<!--PRODUCTS-------------------------------------------------------------------------------->
								<div fxFlex="100%" ngClass="p-r-l">
									<app-products></app-products>
								</div>

								<!--FEATURES-------------------------------------------------------------------------------->
								<div fxFlex="100%" ngClass="p-r-l">
									<app-features></app-features>
								</div>

								<!--SUPPORT-------------------------------------------------------------------------------->
								<div fxFlex="100%" ngClass="p-r-l">
									<app-support></app-support>
								</div>
							</div>
						</div>
					</mat-menu>
					<mat-menu #productsMenu="matMenu" id="headerProductsMenu">
						<button
							i18n="@@header_label_whydonatePlatform"
							(click)="languageForWhydonatePlatform()"
							mat-menu-item
							id="headerWhydonatePlatform"
						>
							Whydonate Platform
						</button>
						<button
							i18n="@@header_menu_button_donationPlugin"
							(click)="languageForDonationPlugin()"
							mat-menu-item
							id="headerDonationPlugin"
						>
							Donation Plugin
						</button>
						<!-- <button
                            i18n="@@header_menu_button_digitalPinBox"
                            (click)="languageForDigitalPinBox()"
                            mat-menu-item
                            id="headerDigitalPinBox"
                        >
                            Digital PIN Box
                        </button> -->
					</mat-menu>
					<mat-menu
						#fundraiserForMenu="matMenu"
						id="fundraiserForMenu"
						fxHide.sm="true"
						fxHide.xs="true"
					>
						<app-fundraiser-for-header></app-fundraiser-for-header>
					</mat-menu>
					<!--END OF HIDE IF MOBILE-->
				</div>
			</div>
			<!--END LEFT MENU ITEMS-->
			<div fxLayout="column" fxLayoutAlign="center center">
				<div fxLayout="row">
					<!--LOGO-->
					<img
						id="headerLogo"
						class="pointer logo"
						[src]="this.logo"
						(click)="routeToHome()"
					/>
				</div>
			</div>
			<!--RIGHT MENU ITEMS-->
			<div fxFlex="100%" fxLayout="column" fxLayoutAlign="end end">
				<div fxLayout="row" fxLayoutAlign="end center">
					<button
						*ngIf="!isCustomDomainActive"
						class="search"
						fxHide.sm="true"
						fxHide.xs="true"
						i18n="@@header_menu_button_searchFundraisers"
						mat-flat-button
						id="headerSearchFundraiser"
						(click)="routeToSearch()"
						[ngStyle]="{
							color: activeItem === 'search' ? '#32BF55' : '#000000'
						}"
					>
						Search
					</button>
					<!--IF USER IS LOGGED IN-->

					<mat-menu #userMenu="matMenu">
						<mat-card class="mat-elevation-z0">
							<!-- Profile Info -->
							<mat-card-header>
								<img
									*ngIf="profileImage"
									mat-card-avatar
									[src]="profileImage"
									i18n="@@profile_image_alt_description"
									alt="This is the profile image"
								/>
								<!-- Profile name -->
								<mat-card-title>
									{{ this.userProfile?.data?.profile?.name }}
								</mat-card-title>
								<mat-card-subtitle
									matTooltip="{{
										shouldShowTooltip(userProfile?.data?.profile?.email || '')
											? userProfile?.data?.profile?.email
											: ''
									}}"
									[matTooltipPosition]="'left'"
								>
									{{
										truncateText(this.userProfile?.data?.profile?.email || '')
									}}</mat-card-subtitle
								>
							</mat-card-header>
						</mat-card>
						<mat-divider></mat-divider>
						<button
							mat-menu-item
							(click)="this.userMenuClick('myAccount')"
							id="headerMyAccount"
						>
							<img
								class="icon-position"
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/account_circle/public"
							/>&nbsp;&nbsp;&nbsp;
							<span i18n="@@header_userMenu_button_myAccount" class="mat-typography">
								My Account
							</span>
						</button>
						<button
							mat-menu-item
							(click)="this.userMenuClick('helpCenter')"
							id="headerHelpCenter"
						>
							<img
								class="icon-position"
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/helpNav/public"
							/>&nbsp;&nbsp;&nbsp;
							<span i18n="@@header_userMenu_button_helpCenter" class="mat-typography">
								Help Center
							</span>
						</button>
						<button
							mat-menu-item
							(click)="this.userMenuClick('logout')"
							id="headerLogout"
						>
							<img
								class="icon-position"
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/logout/public"
							/>&nbsp;&nbsp;&nbsp;
							<span i18n="@@header_userMenu_button_logout" class="mat-typography">Logout </span>
						</button>
						<mat-divider
							*ngIf="!isCustomDomainActive"
							fxHide.gt-sm="true"
							fxHide.sm="false"
						>
						</mat-divider>
						<div fxHide.gt-sm="true" fxHide.sm="false">
							<ng-container
								*ngIf="!isCustomDomainActive"
								[ngTemplateOutlet]="headerMenuAccordion"
							></ng-container>
						</div>
					</mat-menu>
					<!--END IF USER IS LOGGED IN-->
					<!--IF USER IS NOT LOGGED IN-->
					<div
						fxHide.lg="true"
						fxHide.lt-lg="true"
						fxHide.gt-lg="true"
						fxHide.sm="false"
						fxHide.lt-sm="false"
					>
						<button mat-icon-button (click)="routeToSearch()">
							<img
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/search/public"
							/>
						</button>
					</div>
						<img
						    *ngIf="this.isLoggedIn"
							id="headerMenu"
							class="profile-image pointer p-l-s p-r-s"
							[src]="this.profileImage"
							(error)="handleImageError($event)"
							[matMenuTriggerFor]="userMenu"
						/>
					<button
						id="loginButton"
						fxHide.sm="false"
						fxHide.xs="false"
						*ngIf="!this.isLoggedIn"
						i18n="@@button_login"
						mat-flat-button
						(click)="routeToLogin()"
						[ngStyle]="{
							color: activeItem === 'login' ? '#32BF55' : '#000000'
						}"
					>
						Login
					</button>
					<app-start-fundraiser-button
						fxHide.xs="true"
						buttonType="stroked"
						themeColor="accent"
						id="startFundraiserButton"
						ngClass="p-l-m"
					>
					</app-start-fundraiser-button>
					<!--MENU FOR MOBILE-->
					<mat-menu #mobileMenu="matMenu">
						<ng-container
							*ngIf="!isCustomDomainActive"
							[ngTemplateOutlet]="headerMenuAccordion"
						></ng-container>
						<button
							id="loginButton"
							*ngIf="!this.isLoggedIn"
							i18n="@@button_login"
							mat-menu-item
							(click)="routeToLogin()"
							[ngStyle]="{
								color: activeItem === 'login' ? '#32BF55' : '#000000'
							}"
						>
							<span ngClass="p-l-xs">Login</span>
						</button>
					</mat-menu>
					<!--MENU FOR MOBILE-->
					<!--END OF IF USER IS NOT LOGGED IN-->
				</div>
			</div>
		</div>
	</mat-toolbar-row>
	<mat-toolbar-row fxHide.gt-xs="true">
		<div fxLayout="column" fxFlex="100%" class="white-bg">
			<app-start-fundraiser-button buttonType="stroked" themeColor="accent">
			</app-start-fundraiser-button>
		</div>
	</mat-toolbar-row>
</mat-toolbar>

<ng-template #headerMenuAccordion>
	<mat-accordion class="mobileMenuContainer">
		<mat-expansion-panel (click)="$event.stopPropagation()">
			<mat-expansion-panel-header>
				<mat-panel-title i18n="@@footer_label_fundraiserFor"
					>Fundraiser For</mat-panel-title
				>
			</mat-expansion-panel-header>
			<app-fundraiser-for [showFundraiserHeader]="false"></app-fundraiser-for>
		</mat-expansion-panel>
		<mat-expansion-panel (click)="$event.stopPropagation()">
			<mat-expansion-panel-header>
				<mat-panel-title i18n="@@footer_label_products"
					>Product</mat-panel-title
				>
			</mat-expansion-panel-header>
			<p
				i18n="@@header_label_whydonatePlatform"
				(click)="languageForWhydonatePlatform()"
				id="headerWhydonatePlatform"
			>
				Whydonate Platform
			</p>
			<p
				i18n="@@header_menu_button_donationPlugin"
				(click)="languageForDonationPlugin()"
				id="headerDonationPlugin"
			>
				Donation Plugin
			</p>
		</mat-expansion-panel>
		<mat-expansion-panel (click)="$event.stopPropagation()">
			<mat-expansion-panel-header>
				<mat-panel-title i18n="@@footer_label_features"
					>Features</mat-panel-title
				>
			</mat-expansion-panel-header>
			<app-features [showFeaturesHeader]="false"></app-features>
		</mat-expansion-panel>
		<mat-expansion-panel (click)="$event.stopPropagation()">
			<mat-expansion-panel-header>
				<mat-panel-title i18n="@@footer_label_support">About</mat-panel-title>
			</mat-expansion-panel-header>
			<app-support [showSupportHeader]="false"></app-support>
		</mat-expansion-panel>
	</mat-accordion>
</ng-template>
